import React from "react";

import * as Styles from "./styles";

interface Props {
  value: number[];
  onValueChange: (val: number[]) => void;
  disabled?: boolean;
}

const QtdDomitorios: React.FC<Props> = ({ value, onValueChange, disabled }) => {
  const onHandleSelect = (item: number) => {
    if (disabled) return;
    const index = value?.indexOf(item);
    const newArray =
      index === -1 ? [...value, item] : value?.filter((v) => v !== item);
    onValueChange(newArray);
  };

  const isValueSelected = (item: number): boolean => {
    return value?.includes(item);
  };

  return (
    <Styles.Container>
      <Styles.Item
        isSelected={isValueSelected(1)}
        disabled={disabled}
        onClick={() => onHandleSelect(1)}
      >
        <Styles.ItemText isSelected={isValueSelected(1)}>1</Styles.ItemText>
      </Styles.Item>
      <Styles.Item
        isSelected={isValueSelected(2)}
        disabled={disabled}
        onClick={() => onHandleSelect(2)}
      >
        <Styles.ItemText isSelected={isValueSelected(2)}>2</Styles.ItemText>
      </Styles.Item>
      <Styles.Item
        isSelected={isValueSelected(3)}
        disabled={disabled}
        onClick={() => onHandleSelect(3)}
      >
        <Styles.ItemText isSelected={isValueSelected(3)}>3</Styles.ItemText>
      </Styles.Item>
      <Styles.Item
        isSelected={isValueSelected(4)}
        disabled={disabled}
        onClick={() => onHandleSelect(4)}
      >
        <Styles.ItemText isSelected={isValueSelected(4)}>4+</Styles.ItemText>
      </Styles.Item>
    </Styles.Container>
  );
};

export default QtdDomitorios;
